import { apiFetch } from "./client";
import type { Page } from "./admin";

export type AuditAction =
  | "CREATE"
  | "UPDATE"
  | "DELETE"
  | "LOGIN"
  | "LOGOUT"
  | "LOGIN_FAILED"
  | "INVITE"
  | "APPROVE"
  | "REJECT"
  | "PASSWORD_RESET_REQUEST"
  | "PASSWORD_RESET_COMPLETE"
  | "TOKEN_REFRESH"
  | "ACCOUNT_LOCKED"
  | "ACCOUNT_UNLOCKED";

export type AuditLogRow = {
  id: string;
  actorUserId: string | null;
  actorName: string | null;
  entityType: string;
  entityId: string | null;
  action: AuditAction;
  beforeData: string | null;
  afterData: string | null;
  ipAddress: string | null;
  userAgent: string | null;
  requestId: string | null;
  createdAt: string;
};

const q = (params: Record<string, string | number | undefined>) => {
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== "") usp.set(k, String(v));
  });
  const s = usp.toString();
  return s ? `?${s}` : "";
};

export const auditApi = {
  search: (params: {
    actorUserId?: string;
    entityType?: string;
    entityId?: string;
    action?: AuditAction;
    from?: string;
    to?: string;
    page?: number;
    size?: number;
  } = {}) =>
    apiFetch<Page<AuditLogRow>>(`/admin/audit-log${q({ ...params, sort: "createdAt,desc" })}`),
};
